export default __webpack_public_path__ + "2737a8e7ac58394889e8367b460b35a3.png";